import AssetsManagementViewImport from './AssetsManagementView';
import Container from './Container';

export const AssetsManagementView = AssetsManagementViewImport;
export { default as AssetsContainer } from './Container';

export const useAssetsBaseProps = Container.useProps;

export default AssetsManagementView;